module.exports = __webpack_public_path__ + "static/media/2 (39).8c53caad.jpg";